import { parseUnits, readContract, writeContractAndWait } from "../viem";
import { approveToken, getTokenAllowance } from ".";
import config from "../../config/config";
import MafiaMarketingProposalAbi from "../../abis/MafiaMarketingProposal.json";

const address = config.proposalAddress;
const abi = MafiaMarketingProposalAbi;

export const createProposal = async (
  duration: number,
  options: any[],
  account: string
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "createProposal",
    args: [duration, options],
    account,
  });

  return data;
};

export const openProposal = async (proposalId: number, account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "openProposal",
    args: [proposalId],
    account,
  });

  return data;
};

export const voteOnProposal = async (
  proposalId: number,
  optionId: number,
  amount: number,
  account: string
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "voteOnProposal",
    args: [proposalId, optionId, parseUnits(amount.toFixed(18), 18)],
    account,
  });

  return data;
};

export const withdrawVoteToken = async (
  proposalId: number,
  account: string
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "withdrawVoteToken",
    args: [proposalId],
    account,
  });

  return data;
};

export const closeProposal = async (proposalId: number, account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "closeProposal",
    args: [proposalId],
    account,
  });

  return data;
};

export const getProposals = async () => {
  const data = await readContract({
    address,
    abi,
    functionName: "getProposals",
  });

  return data;
};

export const getIsAdmin = async (account: string) => {
  const data = await readContract({
    address,
    abi,
    functionName: "isAdmin",
    args: [account],
  });

  return Boolean(data);
};

export const approveMafiaToVote = async (account: string, amount: number) => {
  const allowance = await getTokenAllowance(
    config.mafiaAddress,
    account,
    config.proposalAddress
  );

  if (Number(allowance) < amount) {
    await approveToken(
      config.mafiaAddress,
      amount,
      config.proposalAddress,
      account
    );
  }
};

export const getProposalIds = async () => {
  const data = await readContract({
    address,
    abi,
    functionName: "proposalIds",
  });
  return Number(data);
};

export const getUserVotes = async (
  signature: string,
  signMsg: string,
  account: string,
  completedIds: number[]
) => {
  const data = await readContract({
    address,
    abi,
    functionName: "getUserVotes",
    args: [account, completedIds, JSON.stringify(signMsg), signature],
  });
  return data;
};

export const editDelivery = async (
  account: string,
  optionIds: number[],
  links: string[],
  roundId: number
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "updateDelieveryLinks",
    args: [roundId, optionIds, links],
    account,
  });

  return data;
};

export const cancelProposal = async (account: string, roundId: number) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "cancelProposal",
    args: [roundId],
    account,
  });
  return data;
};
